// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3CeEm","select":"Header_select__3kGh-","clinic":"Header_clinic__1IJ92"};